import * as React from "react";
import { useNavigate } from "react-router-dom";
import EditIcon from '../../utils/media/icons/edit_icon.png';
// import ViewIcon from '../../utils/media/icons/view_icon.png';
import DeleteIcon from '../../utils/media/icons/delete_icon.png';
import { deleteNgo, updateNgo } from "../../api/users";
import ActiveStatus from '../../components/Common/ActiveStatus';
import Chip from "../../components/Chip";

function NgoTable({ users, toast }) {
    
    const navigate = useNavigate();
    
    const [selectedRows, setSelectedRows] = React.useState(new Set());

    const getTimestamp = (user) => {
        // Prefer createdAt; fallback to Mongo ObjectId embedded timestamp
        if (user?.createdAt) {
            const d = new Date(user.createdAt);
            return isNaN(d.getTime()) ? 0 : d.getTime();
        }
        if (user?._id) {
            try {
                // ObjectId timestamp (first 8 hex chars are seconds)
                const sec = parseInt(user._id.toString().substring(0, 8), 16);
                return sec * 1000;
            } catch (err) {
                return 0;
            }
        }
        return 0;
    };

    const sortedUsers = React.useMemo(() => users.slice().sort((a, b) => getTimestamp(b) - getTimestamp(a)), [users]);

    const toggleSelectAll = () => {
        if (selectedRows.size === sortedUsers.length) {
            setSelectedRows(new Set());
        } else {
            setSelectedRows(new Set(sortedUsers.map(user => user._id)));
        }
    };

    const toggleSelectRow = (id) => {
        const newSelected = new Set(selectedRows);
        if (newSelected.has(id)) {
            newSelected.delete(id);
        } else {
            newSelected.add(id);
        }
        setSelectedRows(newSelected);
    };

    const handleEdit = (id, userType) => {
        if(userType === 'regular') navigate('/user/edit/user', { state: { _id: id }});
        else if(userType === 'ambassador') navigate('/user/edit/ambassador', { state: { _id: id }});
        else if(userType === 'Company') navigate('/user/create/company', { state: { _id: id }});
        else if(userType === 'NGO') navigate('/user/create/ngo', { state: { _id: id }});
    }
    
    const handleDelete = (id) => {
        const con = window.confirm('Are you sure you want to delete this user?');
        con && deleteNgo(id, toast);
    }
    
    if(users.length === 0) {
        return (
            <div className="w-full h-96 flex items-center justify-center">
                <h1 className="text-xl text-gray-400">No NGO Found!</h1>
            </div>
        );
    }
    
    return (
        <div className="overflow-x-auto mt-6">
            <table className="w-full border-collapse text-base" role="table">
                <thead className="bg-navBtn">
                    <tr className="rounded-md">
                        <th className="p-3 text-left">
                            <input
                                type="checkbox"
                                className="h-4 w-4 rounded border-gray-300 accent-primary"
                                checked={selectedRows.size === sortedUsers.length}
                                onChange={toggleSelectAll}
                                aria-label="Select all users"
                            />
                        </th>
                        <th className="p-3 text-left">Srl. No.</th>
                        <th className="p-3 text-left">NGO Name</th>
                        <th className="p-3 text-left">User Name</th>
                        <th className="p-3 text-left">Point of Contact Name</th>
                        <th className="p-3 text-left">Point of Contact Email</th>
                        <th className="p-3 text-left">Point of Contact Phone</th>
                        <th className="p-3 text-left">Partnership Start Date</th>
                        <th className="p-3 text-left">Type of Engagement</th>
                        <th className="p-3 text-left">Status</th>
                        <th className="p-3 text-left">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {sortedUsers.map((user, id) => (
                        <tr
                            key={user._id}
                            className="border-b border-navBtn hover:bg-gray-50"
                        >
                            <td className="p-3">
                                <input
                                    type="checkbox"
                                    className="h-4 w-4 rounded border-gray-300 accent-primary mt-1"
                                    checked={selectedRows.has(user._id)}
                                    onChange={() => toggleSelectRow(user._id)}
                                    aria-label={`Select ${user.name}`}
                                />
                            </td>
                                <td className="p-3">{id + 1}</td>
                            <td className="p-3">{user.name || '-'}</td>
                            <td className="p-3">{user.username || '-'}</td>
                            <td className="p-3">{user.pointOfContact?.pocName || '-'}</td>
                            <td className="p-3">{user.pointOfContact?.pocEmail || '-'}</td>
                            <td className="p-3">{user.pointOfContact?.pocPhone || '-'}</td>
                            <td className="p-3">{user.partnershipStartDate ? new Date(user.partnershipStartDate).toLocaleDateString() : '-'}</td>
                            <td className="p-3">{user.typesOfEngagement ? (Array.isArray(user.typesOfEngagement) ? user.typesOfEngagement.join(', ') : user.typesOfEngagement) : '-'}</td>
                            <td className="p-3">
                                <Chip value={user.active === 'true' || user.active === true ? 'Active' : 'Inactive'} color={user.active === 'true' || user.active === true ? 'green' : 'red'} />
                            </td>
                            <td className="p-3">
                                <button className="rounded p-1.5 bg-[rgba(0,122,155,0.1)] hover:bg-[rgba(0,122,155,0.2)] min-h-7 mr-1" onClick={() => handleEdit(user._id, user.userType)}>
                                    <img src={EditIcon} alt="edit" className="w-4 h-4" />
                                </button>
                                {/* <button className="rounded p-1.5 bg-[rgba(52,199,89,0.1)] hover:bg-[rgba(52,199,89,0.2)] mx-1 min-h-7" onClick={() => navigate('/user/view/user', { state: { _id: user._id } })}>
                                    <img src={ViewIcon} alt="view" />
                                </button> */}
                                <button className="rounded p-1.5 bg-[rgba(250,22,22,0.1)] hover:bg-[rgba(250,22,22,0.2)] min-h-7 ml-1 px-2" onClick={() => handleDelete(user._id, user.userType)}>
                                    <img src={DeleteIcon} alt="delete" />
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default NgoTable;